import {getLayoutData, getPageData} from "@/pages/api/api";
import {useBranch} from "@/hooks/useBranch";
import {useRouter} from "next/router";
import {SINGLE_PAGE_QUERY} from "@/pages/api/fragments";
import useSetBannerData from "@/hooks/useSetBannerData";
import {useTransformedMenuContext} from "@/layout/Layout";
import {useMemo} from "react";
import {formatToCardItem} from "@/components/common/Cards";
import ExtendedContent from "@/components/common/ExtendedContent";
import ListCards from "@/components/common/Cards/List";
import {PAGES} from "@/constants";

export default function PolishRedCross({data, locale, menu}) {
	const router = useRouter();
	// const pageName = data?.pageName || '';
	const slug = data?.slug || '';
	const content = data?.content || []
	const bannerData = useSetBannerData(data)
	const { selectedOption } = useBranch();
	const transformedMenuData = useTransformedMenuContext('menuData');
	const currentData = useMemo(
		() => transformedMenuData.find(({ universalLink }) => universalLink.link.link.id === data.id),
		[data.id, transformedMenuData]
	);

	const formattedCardsData = useMemo(() => {
		return currentData?.children
			?.filter(({ universalLink }) => universalLink?.link?.link?.card) //build fix
			.map(({ universalLink }) => formatToCardItem(universalLink.link.link)) || [];
	}, [currentData]);

	return(
		<>
			<ExtendedContent content={content} globalBannerData={bannerData} />
			{/*<Container>*/}
			<ListCards data={formattedCardsData} noDateColumn mobileSliderEnabled={false} />
			{/*</Container>*/}
		</>

	)
}

const POLISH_RED_CROSS_PAGE_QUERY = `
	query GetPolishRedCrossPageData($locale: SiteLocale) {
		allSinglePages(locale: $locale,  filter: {slug: {eq: "${PAGES.POLISH_RED_CROSS}"}}) {
			__typename
			${SINGLE_PAGE_QUERY}
		}
	}
`;

export async function getStaticProps(context) {
	const locale = context?.locale || 'pl';
	const data = await getPageData('allSinglePages', 'polski-czerwony-krzyz', POLISH_RED_CROSS_PAGE_QUERY, locale);
	const layout = await getLayoutData(locale)
	return {
		props: {
			data,
			locale,
			...layout,
			isDarkSearch: true
		},
		revalidate: 60 * 2
	};
}
